import React from "react"
import { Query } from "react-apollo"
import FavoritesFile from "../../views/MyFavorites/components/FavoriteFile"
import Dashboard from "./Dashboard"
import Loading from "../Loading"
import ContentCard from "../ContentCard"
import { getRecentFavorites } from "../../views/MyFavorites/queries"

import "./style.scss"

const DashboardFavorites = (props) => {
  return (
    <Query query={getRecentFavorites} fetchPolicy="cache-and-network">
      {({ data, error, loading }) => {
        const contentCardStyles = { marginBottom: ".8rem" }
        if (error || !data || !data.searchFavorites) {
          return (
            <ContentCard style={contentCardStyles}>
              An unknown error has occured while getting recently viewed
              favorites.
            </ContentCard>
          )
        }

        if (loading) {
          return (
            <ContentCard style={contentCardStyles}>
              <Loading />
            </ContentCard>
          )
        }

        return (
          <Dashboard
            trackEvent={props.trackEvent}
            trackingLocation="Home Dashboard"
          >
            {data.searchFavorites.map((favorite, idx) => {
              return (
                <FavoritesFile
                  key={idx}
                  hasMenu={false}
                  favorite={favorite}
                  trackingLocation="Home Dashboard"
                />
              )
            })}
          </Dashboard>
        )
      }}
    </Query>
  )
}

export default DashboardFavorites
